import { FC } from 'react';
import FormFields from 'components/formFields';
import { useTabbedForm } from 'hooks';
import { manualPaymentsTabs } from './config';
import MassRequest from 'pages/payouts/components/massRequest';

export const ManualPaymentsForm: FC = () => {
  const { selectedTabId, tabs, handleChangeTab } = useTabbedForm({
    initialTabs: manualPaymentsTabs,
    basePath: '/manual-payments',
  });

  return (
    <FormFields
      id={selectedTabId}
      title='manualPayments.massRequest.form.title'
      tabs={tabs}
      formFields={
        <MassRequest type={selectedTabId} backUrl='/manual-payments' />
      }
      onBeforeChange={(_, id) => handleChangeTab(id!)}
    />
  );
};
